<template>
  <div class="section-box">
    <!-- 搜索 -->
    <div class="customer-list">
      <el-row class="customer-row-bg">
        <el-col
          :span="20"
          style="text-align: left; display: flex; align-items: center"
        >
          <el-form :inline="true" label-width="90px" label-position="left">
            <el-form-item label="昵称">
              <el-input v-model="form.nickName"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form
            inline
            label-width="90px"
            label-position="left"
            style="text-align: right"
          >
            <el-form-item>
              <el-button size="medium" type="primary" @click="handleSearch"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button size="medium" type="success" @click="handleReset"
                >重置</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button size="medium" type="info" @click="downFile"
                >导出Excel</el-button
              >
            </el-form-item>


            
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!-- 列表 -->
    <el-table
      :stripe="true"
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
      height="500"
      :header-cell-style="{ background: '#F5F7FA' }"
      v-loading="listLoading"
    >
      <!-- eslint-disable  -->
      <el-table-column label="序号" width="60" type="index" :index="getIndex">
        <!-- <template slot-scope="scope">
                        <span>{{scope.row.n || '--'}}</span>
                    </template> -->
      </el-table-column>
      <el-table-column label="昵称" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.NickName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="头像" width="100">
        <template slot-scope="scope">
          <el-image
            v-if="scope.row.HeadImg != ''"
            style="width: 50px; height: 50px"
            :src="scope.row.HeadImg"
          ></el-image>
          <i v-else class="el-icon-user-solid"></i>
        </template>
      </el-table-column>
      <el-table-column label="笔试成绩" width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.FirstScore >= 0"
            >{{ scope.row.FirstScore }}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="笔试用户名称" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.FirstScore >= 0"
            >{{ scope.row.FirstScoreUserName }}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="笔试用户手机" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.FirstScore >= 0"
            >{{ scope.row.FirstScoreUserPhone }}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="笔试用户城市" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.FirstScore >= 0"
            >{{ scope.row.FirstScoreUserCity }}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="视频考试成绩" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.SecondScore >= 0"
            >{{ scope.row.SecondScore }}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="总邀请人数" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.TotalInviteCount || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="有效邀请人数" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.AvailableInviteCount || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="领奖用户名称" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.PrizeUserName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="领奖用户手机" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.PrizeUserPhone || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="领奖用户地址" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.PrizeUserAddress || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="邀请用户名称" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.InviUserName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="邀请用户手机" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.InviUserPhone || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="邀请用户地址" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.InviUserAddress || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="参与活动时间" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.CreateTimeStr || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button size="mini" @click="videoDetail(scope.row)"
            >查看视频打分</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div style="margin: 10px; overflow: hidden">
      <div style="float: right" v-show="tableData.length">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 视频列表 -->
    <engineerExamVideoList
      ref="engineerExamVideo"
      @videoPlay="videoPlay"
      @reloadList="reloadList"
    />

    <!-- 播放视频 -->
    <el-dialog
      title="播放视频"
      :visible.sync="isShowPlayVideo"
      width="735px"
      append-to-body
      @close="closeVideoPlayDia"
    >
      <div class="video-title" v-if="selectUserVideo">
        问题：{{ selectUserVideo.QuestionsTitle }}
      </div>
      <div class="video-zone">
        <video
          ref="videoRef"
          v-if="selectUserVideo"
          :src="selectUserVideo.EngineerAnswer"
          class="avatar"
          controls="controls"
          autoPlay
        >
          您的浏览器不支持视频播放
        </video>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getActivityUserList, //获取自由工单列表
  getDownVideoExamUrl
} from "@/service/run";
import engineerExamVideoList from "./engineerExamVideoList";
export default {
  components: {
    engineerExamVideoList,
  },
  data() {
    return {
      listLoading: false,
      form: {
        pageNum: 1,
        pageSize: 10,
        nickName: "",
      },
      regionForm: {}, //保存form原始搜索参数
      searchData: {},
      total: 0, //总条数
      tableData: [],

      selectUser: null, //选择的用户
      selectUserVideo: null, //选择的用户的其中一条视频
      isShowPlayVideo: false, //
    };
  },
  // activated(){
  //     this.handleSearch()
  // },
  created() {
    this.oraginForm = JSON.parse(JSON.stringify(this.form));
    this.tableData = [];
    this.handleSearch();
  },
  methods: {
    // 查询
    handleSearch() {
      this.searchData = Object.assign({}, this.form);
      this.handleCurrentChange(1);
    },
    // 重置
    handleReset() {
      this.form = JSON.parse(JSON.stringify(this.oraginForm));
      this.handleSearch();
    },
    handleSizeChange(val) {
      if (this.listLoading) return;
      this.form.pageNum = 1;
      this.form.pageSize = val;
      this.searchData.pageNum = 1;
      this.searchData.pageSize = val;
      this.getEngineerList();
    },
    handleCurrentChange(val) {
      if (this.listLoading) return;
      this.form.pageNum = val;
      this.searchData.pageNum = val;
      this.getEngineerList();
    },
    //获取活动工程师列表
    async getEngineerList() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.searchData));

      let res = await getActivityUserList(data);
      this.listLoading = false;
      if (res.Result != 1) {
        return this.$message.error("获取失败请联系开发人员");
      }
      this.tableData = res.Data.UserList;
      this.total = res.Data.TotalCount;
    },
    getIndex(index) {
      return (this.form.pageNum - 1) * this.form.pageSize + index + 1;
    },

    //查看视频
    videoDetail(row) {
      if (row.SecondScore < 0) {
        return this.$message.error("该用户暂未视频考试");
      }
      this.selectUser = row;
      this.$refs.engineerExamVideo.openDia(this.selectUser);
      this.$refs.engineerExamVideo.loadList();
    },

    //播放视频
    videoPlay(vv) {
      console.log("触发");
      this.selectUserVideo = vv;
      this.isShowPlayVideo = true;
      console.log("宽度：" + this.$refs.videoRef.videoWidth);
    },
    closeVideoPlayDia() {
      console.log("关闭弹窗");
      this.selectUserVideo = null;
    },
    reloadList() {
      console.log("重新加载：pageNum=" + this.form.pageNum);
  
      console.log("isShowPlayVideo=" + this.videoIsShow);
      this.handleCurrentChange(this.form.pageNum);
    },
    downFile() {
      var url = getDownVideoExamUrl();
     
    //   let url2 = (process.env.NODE_ENV == "development" ? "/api4" : process.env.VUE_APP_API4)+"/api/EngineerCompetition/DownActivityUserList";
      console.log("url1:"+url);
    //   console.log("url2:"+url2);
      window.open(url);
    },
  },
};
</script>
<style lang="scss">
.customer-list {
  position: relative;
  .next-button {
    position: absolute;
    right: 0;
    top: -56px;
  }
}
.customer-row-bg {
  padding: 20px 14px;
  background-color: #f9fafc;
  display: flex;
  align-items: center;
  .el-form-item {
    margin-bottom: 0 !important;
  }
  .selected {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }
}
.el-dialog__body {
  padding: 10px;
}
.video-title {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
  padding: 5px;
}
.video-zone {
  text-align: center;
}
.video-zone video {
  max-width: 720px;
  max-height: 500px;
}
</style>